import { StringFormatter } from '@repo/toolkit/string'
import Button from '@repo/ui/button'
import { Column } from '@repo/ui/data-table'
import { useState } from 'react'

import { API } from '../../../api/apis.config'
import { User } from '../../../lib/types/models/users/user'
import { IdInput } from '../../../lib/types/utils'
import DynamicDataTable from '../../elements/dynamic-table'

type LecMissionUser = {
  id: number
  user: User
  missionCount: number
}

type Props = {
  className?: string
  missionId: number
  isLoading?: boolean
  onCancel: () => void
  onSubmit: (user: LecMissionUser[]) => void
}

export function MissionLecStaffList({
  className,
  missionId,
  onSubmit,
  onCancel,
  isLoading
}: Props) {
  const [selectedStaffs, setSelectedStaffs] = useState<LecMissionUser[]>([])

  const columns: Column<IdInput<LecMissionUser>>[] = [
    {
      enableSorting: true,
      accessorKey: 'lastName',
      header: 'NOM',
      cell: ({ row }) => row.original.user.lastName.toUpperCase()
    },
    {
      enableSorting: true,
      accessorKey: 'firstName',
      header: 'Prénom',
      cell: ({ row }) => StringFormatter.capitalize(row.original.user.firstName)
    },
    {
      accessorKey: 'missionCount',
      header: 'Nombre de missions identiques',
      cell: ({ row }) => row.original.missionCount ?? '-'
    }
  ]

  return (
    <div>
      <div className={className}>
        <DynamicDataTable<LecMissionUser>
          columns={columns}
          selectable
          headerType="light"
          allowSearchParam
          version={'FULL'}
          onSelectedDataChange={({ rows }) => setSelectedStaffs(rows)}
          selectedData={{ rows: selectedStaffs, isAllSelected: false }}
          permissions={{ delete: false }}
          endpoint={API.missions.getMissionLecStaffOptions.url.replace(
            ':id',
            missionId.toString()
          )}
        />
      </div>

      <div
        className={'flex justify-end w-full gap-3 pt-5 border-t border-t-white-active p-5 mt-5'}
      >
        <Button
          disabled={isLoading}
          variant="ghost"
          type="button"
          label={'Fermer'}
          aria-label={'Fermer'}
          onClick={onCancel}
        />
        <Button
          loading={isLoading}
          label={'Valider'}
          aria-label={'Valider'}
          onClick={() => onSubmit(selectedStaffs)}
        />
      </div>
    </div>
  )
}
